<template>
  <li class="horizontal-slider-item">
    <slot />
  </li>
</template>

<script>
export default {
  name: 'HorizontalSliderItem'
}
</script>

<style lang="scss">
@import "/assets/css/components";

.horizontal-slider-item {
  // Auto vertical sizing
  margin-bottom: auto;

  > * {
    &:focus, &:focus-visible {
      outline: none;
    }
  }

  * {
    user-select: none;
    -webkit-user-drag: none;
  }

  &:has(> *:focus-visible) {
    box-shadow: 0 0 0 2px $primary;
    padding: $padding-1;
    margin: -$margin-1;
    margin-bottom: auto;
    background: lighten($primary, 50%);
    border-radius: $border-radius-xs;
  }
}
</style>
